import axios from 'axios';
import { ApiEndpoints } from './urls';
import { drfQueryParams } from './utils';

class ActivityTemplateApi {
  // ------ Roster Template API ------
  static getAllActivityTemplates(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.activityTemplatesList, { params });
  }

  static getActivityTemplate({ id }) {
    return axios.get(ApiEndpoints.activityTemplate.replace(':id:', id));
  }

  static createActivityTemplate(params) {
    return axios.post(ApiEndpoints.activityTemplatesList, params);
  }

  static cloneActivityTemplate(id) {
    return axios.post(ApiEndpoints.activityTemplateClone.replace(':id:', id));
  }

  static updateActivityTemplate(data) {
    const { id } = data;
    return axios.patch(ApiEndpoints.activityTemplate.replace(':id:', id), data);
  }

  static deleteActivityTemplate({ id }) {
    return axios.delete(ApiEndpoints.activityTemplate.replace(':id:', id));
  }

  // ------ Saves the activities to a template -------
  static saveActivityTemplateActivities(template_id, activities) {
    return axios.post(
      `${ApiEndpoints.activityTemplateActivities.replace(':id:', template_id)}bulk_update/`,
      activities
    );
  }
}

export default ActivityTemplateApi;
